/**
 * アコーディオンの初期化
 */
const accordion = () => {
  const accordions = document.querySelectorAll('.js-accordion');

  if (accordions.length === 0) {
    return;
  }

  accordions.forEach((accordion, index) => {
    const button = accordion.querySelector('.js-accordion__button');
    const panel = accordion.querySelector('.js-accordion__panel');

    if (!button || !panel) {
      return;
    }

    // 既に初期化済みかチェック（重複登録を防ぐ）
    if (button.dataset.accordionInitialized === 'true') {
      return;
    }

    // ユニークなIDを生成
    const panelId = `accordion-panel-${index}`;
    const buttonId = `accordion-button-${index}`;

    // aria属性を設定
    button.setAttribute('aria-controls', panelId);
    button.setAttribute('id', buttonId);
    panel.setAttribute('aria-labelledby', buttonId);
    panel.setAttribute('id', panelId);

    // 初期状態の設定（hidden属性の有無で判定）
    const isInitiallyHidden = panel.hasAttribute('hidden');
    if (isInitiallyHidden) {
      // hidden属性がある場合は削除して閉じた状態にする
      panel.removeAttribute('hidden');
      panel.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    } else {
      // hidden属性がない場合は開いた状態にする
      panel.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    }

    // クリックハンドラー関数を定義（同じ参照を保持するため）
    const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();

      // 現在の状態を取得（クリック直前の状態）
      const wasOpen = panel.classList.contains('is-open');

      // トグル処理
      if (wasOpen) {
        // 閉じる: クラスを確実に削除
        panel.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      } else {
        // 開く: クラスを確実に追加
        panel.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    };

    // ボタンにクリックイベントを追加
    button.addEventListener('click', handleClick);

    // 初期化済みフラグを設定
    button.dataset.accordionInitialized = 'true';
  });
};

export { accordion };
